import React from 'react';
import { getTheme, IIconStyles, Stack, StackItem } from '@fluentui/react';
import { QueueConfiguration, QueueStats } from 'services';
import { DashCardStat } from './DashCardStat';

export interface Stats {
  label: string;
  value: string;
  hasIcon: boolean;
  iconStyle?: IIconStyles;
}

// Returns value in Minutes or Hours, depending on it's setting
const renderSlaValue = (caseOpenLifetimeInSeconds: number): number => {
  const hours = caseOpenLifetimeInSeconds / 3600;

  // Return Minutes if under an hour
  if (hours < 1) {
    return hours * 60; // Return the value in Minutes
  } else {
    return hours; // Return the value in Hours
  }
};

// Returns the label in Mintues or Hours, depending on it's setting
const renderSlaLabel = (caseOpenLifetimeInSeconds: number): string => {
  const hours = caseOpenLifetimeInSeconds / 3600;

  if (caseOpenLifetimeInSeconds === 1) {
    return 'MIN';
  } else if (hours < 1) {
    return 'MIN';
  } else if (hours === 1) {
    return 'HR';
  } else {
    return 'HR';
  }
};

export interface DashCardBottomProps {
  config: QueueConfiguration;
  stats: QueueStats;
}

export const DashCardBottom: React.FunctionComponent<DashCardBottomProps> = props => {
  const { palette, fonts } = getTheme();
  const getIconStyle = (iconColor: string): IIconStyles => {
    const iconStyle: IIconStyles = {
      root: {
        color: iconColor,
        fontSize: fonts.large.fontSize,
        lineHeight: fonts.large.lineHeight
      }
    };
    return iconStyle;
  };

  const stats: Stats[] = [
    {
      label: 'Case SLA',
      value:
        renderSlaValue(props.config.caseOpenLifetimeInSeconds).toString() +
        ' ' +
        renderSlaLabel(props.config.caseOpenLifetimeInSeconds),
      hasIcon: false
    },
    {
      label: 'Open cases',
      value: props.stats.casesTotal.toString(),
      hasIcon: false
    },
    {
      label: 'Near SLA',
      value: props.stats.casesTotalNearingCaseOpenLifetime.toString(),
      hasIcon: props.stats.casesTotalNearingCaseOpenLifetime >= 1 ? true : false,
      iconStyle: getIconStyle(palette.orangeLighter)
    },
    {
      label: 'Past SLA',
      value: props.stats.casesTotalExceedingCaseOpenLifetime.toString(),
      hasIcon: props.stats.casesTotalExceedingCaseOpenLifetime >= 1 ? true : false,
      iconStyle: getIconStyle(palette.red)
    }
  ];

  return (
    <Stack horizontal className="py-4">
      {stats.map(stat => (
        <StackItem grow key={stat.label}>
          <DashCardStat
            label={stat.label}
            value={stat.value}
            hasIcon={stat.hasIcon}
            iconStyle={stat.iconStyle}
            key={stat.label}
          />
        </StackItem>
      ))}
    </Stack>
  );
};

export default DashCardBottom;
